import React, { FunctionComponent } from 'react';

import Styled from './IndigoAvatar.styled';
import defaultImage from '@assets/img/AvartarDefault.png';

interface IndigoAvatarProps {
  imgPath: string;
}

export const IndigoAvatar: FunctionComponent<IndigoAvatarProps> = ({
  imgPath,
}) => {
  return (
    <Styled.Avatar>
      <div className="avatar-cont">
        <img
          src={imgPath === '' ? defaultImage : imgPath}
          alt="Avatar"
          // onLoad={() => {
          //   console.log('sample load');
          // }}
        />
      </div>
    </Styled.Avatar>
  );
};
